import styled, { keyframes } from 'styled-components'
import { Link } from 'react-router-dom'

export const Img = styled.img`
  margin-right: 0.5rem;
  width: 100%;
  max-width: 100px;
  height: 100%;
  margin-left: 9rem;
  margin-left: 30px;
`

export const CustomLink = styled(Link)`
  text-decoration: none;
  color: #ffffff;
  font-size: 14px;
  margin-top: 8px;
  transition: color 0.2s ease, opacity 0.2s ease;

  &:hover {
    color: #ffffff;
    opacity: 0.8;
  }
`

export const Centered = styled.div`
  display: flex;
  justify-content: center;
`

export const Section = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  min-height: calc(100vh - 160px);
`

export const SectionContainer = styled.section`
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  min-height: 390px;
  padding-top: 20px;
  width: 340px;

  h3 {
    text-align: left;
    font-weight: 600;
    font-size: 1.05rem;
    letter-spacing: 0.02em;
    margin: 28px 0 16px;
  }

  @media only screen and (max-width: 600px) {
    background-color: transparent;
    border: none;
    box-shadow: none;
    padding: 0 16px;
    width: 100%;
  }
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 14px;

  & label {
    font-size: 14px;
  }
`

export const FieldError = styled.span`
  color: #ff8a65;
  font-size: 12px;
  margin-top: -8px;
  padding-left: 4px;
`

export const Recover = styled.div`
  color: white;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`

export const Button = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: linear-gradient(135deg, #ffa500 0%, #e08e00 100%);
  border: none;
  border-radius: 12px;
  color: #111;
  cursor: pointer;
  font-size: 15px;
  font-weight: 700;
  font-family: 'Nunito', sans-serif;
  height: 52px;
  letter-spacing: 0.04em;
  margin: 12px 0 10px;
  transition: transform 0.15s ease, box-shadow 0.2s ease, filter 0.2s ease;
  box-shadow: 0 8px 24px rgba(255, 165, 0, 0.28);

  &:hover:not(:disabled) {
    filter: brightness(1.05);
    box-shadow: 0 10px 28px rgba(255, 165, 0, 0.38);
  }

  &:active:not(:disabled) {
    transform: translateY(1px);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.75;
    box-shadow: none;
  }
`

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`

export const Spinner = styled.span`
  width: 18px;
  height: 18px;
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-top-color: #111;
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
  flex-shrink: 0;
`

export const Error = styled.span`
  color: #ff8a65;
  font-size: 14px;
  text-align: center;
  margin-top: 8px;
`

/** Estilo moderno */
export const Input = styled.input`
  background-color: rgba(255, 255, 255, 0.06);
  border: 1px solid
    ${(props) =>
      props.$invalid ? 'rgba(255, 138, 101, 0.85)' : 'rgba(255, 255, 255, 0.18)'};
  border-radius: 12px;
  display: block;
  color: #fff;
  font-family: 'Nunito', sans-serif;
  font-size: 15px;
  height: 52px;
  width: 100%;
  box-sizing: border-box;
  outline: none;
  padding: 0 16px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::placeholder {
    color: rgba(255, 255, 255, 0.45);
  }

  &:hover:not(:disabled):not(:focus) {
    border-color: ${(props) =>
      props.$invalid ? 'rgba(255, 138, 101, 0.95)' : 'rgba(255, 255, 255, 0.32)'};
  }

  &:focus {
    border-color: ${(props) => (props.$invalid ? '#ff8a65' : '#ffa500')};
    background-color: rgba(255, 255, 255, 0.08);
    box-shadow: 0 0 0 3px
      ${(props) =>
        props.$invalid
          ? 'rgba(255, 138, 101, 0.2)'
          : 'rgba(255, 165, 0, 0.22)'};
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  /* Chrome/Safari: anula el fondo claro del autofill */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-text-fill-color: #ffffff !important;
    caret-color: #ffffff;
    border: 1px solid rgba(255, 255, 255, 0.18);
    -webkit-box-shadow: 0 0 0 1000px #1a140c inset !important;
    box-shadow: 0 0 0 1000px #1a140c inset !important;
    transition: background-color 99999s ease-out 0s;
  }
`
